import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: intercept OAuth callback before ProtectedRoute runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-nova-bg text-nova-text min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
